// 메인에서 pull-to-refresh 사용시 메뉴의 간격 처리
// 로그인, 마이컬리등의 간격은 다를 수 있음
export const PULL_TO_REFRESH_MAIN_TOP = 44;
